function createFont(name: string, url: string) {
  const font = new FontFace(name, `url(${url})`);

  document.fonts.add(font);

  return { font, deleteFont: () => document.fonts.delete(font) };
}

const fontCache = new Map<
  string,
  { font: Promise<FontFace>; unload: () => void }
>();

function loadFontOnce({ name, selectors, url }: LoadFontConfig) {
  const cacheKey = `url:${url},selectors:${selectors.join(",")}`;

  if (!fontCache.has(cacheKey)) {
    const { font, deleteFont } = createFont(name, url);

    const unloadFont = () => {
      deleteFont();
      fontCache.delete(cacheKey);
    };

    const loadingFontPromise = font.load();

    loadingFontPromise.catch(unloadFont);

    fontCache.set(cacheKey, {
      font: loadingFontPromise,
      unload: unloadFont,
    });
  }

  return fontCache.get(cacheKey)!;
}

export type LoadFontConfig = {
  name: string;
  url: string;
  selectors: (keyof JSX.IntrinsicElements)[];
};

export function loadFonts(config: LoadFontConfig[]) {
  const fonts = config.map(loadFontOnce);

  return {
    ready: Promise.all(fonts.map((font) => font.font)),
    unloadAll: () => fonts.forEach((font) => font.unload()),
  };
}
